.card {
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-lg);
  padding: 1.3rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: var(--shadow-card);
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}

.title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
}

.subtitle {
  font-size: 0.8rem;
  color: var(--text-secondary);
}

.liveBadge {
  font-family: var(--font-mono);
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.22rem 0.55rem;
  border-radius: 999px;
  background: var(--accent-primary-dim);
  color: var(--accent-primary);
  white-space: nowrap;
}

.controlsRow {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.amountDisplayRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.amountLabel {
  font-size: 0.82rem;
  color: var(--text-secondary);
}

.amountInputWrap {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  background: var(--bg-canvas);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  padding: 0.35rem 0.7rem;
}

.currencyPrefix {
  font-family: var(--font-mono);
  font-weight: 700;
  color: var(--accent-primary);
}

.amountInput {
  width: 110px;
  background: transparent;
  border: none;
  outline: none;
  font-family: var(--font-mono);
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-primary);
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.slider {
  width: 100%;
  accent-color: var(--accent-primary);
  cursor: pointer;
}

.presetRow {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.presetBtn {
  padding: 0.34rem 0.65rem;
  border-radius: 8px;
  border: 1px solid var(--border-subtle);
  background: var(--bg-surface);
  color: var(--text-secondary);
  font-family: var(--font-mono);
  font-size: 0.74rem;
  cursor: pointer;
  transition: all 0.14s ease;
  font-variant-numeric: tabular-nums;
}

.presetBtn:hover,
.presetBtnActive {
  border-color: var(--accent-primary);
  color: var(--text-primary);
  background: var(--accent-primary-dim);
}

.impactGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;
}

.impactBox {
  background: #eff4ff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-md);
  padding: 0.8rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-variant-numeric: tabular-nums;
}

.impactLabel {
  font-size: 0.72rem;
  color: var(--text-secondary);
}

.impactValue {
  font-family: var(--font-display);
  font-size: 1.15rem;
  font-weight: 800;
  color: var(--text-primary);
}

.impactValueWarning {
  color: var(--status-warning);
}

.impactValueDanger {
  color: var(--status-danger);
}

.impactValuePositive {
  color: var(--accent-primary);
}

.narrativeBox {
  padding: 0.8rem 0.95rem;
  border-radius: var(--radius-md);
  font-size: 0.81rem;
  line-height: 1.45;
  border: 1px solid #dce9ff;
  background: #eff4ff;
  color: #0d1c2e;
  font-variant-numeric: tabular-nums;
}

.narrativeDanger {
  border-color: rgba(186, 26, 26, 0.35);
  background: #ffdad6;
  color: #93000a;
}

.actionRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.commitBtn {
  width: 100%;
  padding: 0.68rem 1rem;
  border-radius: var(--radius-md);
  border: 1px solid #00236f;
  background: linear-gradient(135deg, #00236f 0%, #1e3a8a 100%);
  color: #ffffff;
  font-weight: 700;
  font-size: 0.84rem;
  cursor: pointer;
  transition: transform 0.12s ease, opacity 0.12s ease;
  box-shadow: 0 4px 12px rgba(0, 35, 111, 0.18);
}

.commitBtn:hover {
  opacity: 0.94;
}

@media (max-width: 680px) {
  .impactGrid {
    grid-template-columns: 1fr;
  }
}
